// Клиент GET /me/achievements (§миграции достижений): состояние считает бэк,
// фронт только рендерит. Эндпоинт authed-only (в отличие от /me/collection),
// но всё равно зовём через authorizedFetch — Bearer из authStore живёт только
// в памяти (не в куке), плоский fetch залогиненного не аутентифицирует.
// Гостю сюда ходить не нужно: экран не вызывает loadAchievements для гостя.

import { authorizedFetch } from '@/auth/authStore';
import { routes } from '@/api/routes';

export interface Achievement {
  id: string;
  title: string;
  desc: string;
  icon: string;
  done: boolean;
  earnedAt: string | null;
}
export interface AchievementsResponse { achievements: Achievement[] }

export async function loadAchievements(): Promise<AchievementsResponse> {
  const res = await authorizedFetch(routes.meAchievements, { credentials: 'include' });
  if (!res.ok) throw new Error(`achievements ${res.status}`);
  return (await res.json()) as AchievementsResponse;
}
